import React, { forwardRef, type ComponentProps } from 'react'
import styled from '@emotion/styled'
import { Button, buttonColors, buttonSizing, ButtonStyled } from './Button'
import { LoadingSpinner } from '@mobi/component-library/Feedback/LoadingSpinner'

type Props = ComponentProps<typeof Button>

export const PillButton = forwardRef<HTMLButtonElement, Props>(
  ({ children, color = 'primary', isFullWidth = false, size = 'md', isLoading, ...props }, ref) => (
    <PillButtonStyled color={color} isFullWidth={isFullWidth} size={size} {...props} ref={ref}>
      {isLoading ? (
        <LoadingSpinner size='2rem' color={color === 'positive' ? 'white' : 'purple'} />
      ) : (
        children
      )}
    </PillButtonStyled>
  )
)

PillButton.displayName = 'PillButton'

const PillButtonStyled = styled(ButtonStyled)(
  ({ color = 'primary', size = 'md', isFullWidth = false, isIconOnlyButton = false }) => ({
    ...(isFullWidth ? { display: 'flex', width: '100%' } : { display: 'inline-flex' }),

    ...buttonSizing({ isIconOnlyButton, isPillButton: true })[size],
    ...buttonColors[color],
  })
)
